// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file artifacts/analyzer/v1/analyzer_service.proto (package artifacts.analyzer.v1, syntax proto3)
/* eslint-disable */

import { AnalyzerService } from "./analyzer_service_pb";

/**
 * @generated from rpc artifacts.analyzer.v1.AnalyzerService.ListSubcategories
 */
export const listSubcategories = AnalyzerService.method.listSubcategories;

/**
 * @generated from rpc artifacts.analyzer.v1.AnalyzerService.UpdateArtifactSubcategory
 */
export const updateArtifactSubcategory = AnalyzerService.method.updateArtifactSubcategory;

/**
 * @generated from rpc artifacts.analyzer.v1.AnalyzerService.RunPromptOnCompany
 */
export const runPromptOnCompany = AnalyzerService.method.runPromptOnCompany;

/**
 * Support-only: queue analysis of a specific control, bypassing scope/enabled checks
 *
 * @generated from rpc artifacts.analyzer.v1.AnalyzerService.ForceAnalyzeControl
 */
export const forceAnalyzeControl = AnalyzerService.method.forceAnalyzeControl;

/**
 * Support-only: queue analysis of every enabled LLM control of an open assessment
 *
 * @generated from rpc artifacts.analyzer.v1.AnalyzerService.ReanalyzeAssessmentControls
 */
export const reanalyzeAssessmentControls = AnalyzerService.method.reanalyzeAssessmentControls;

/**
 * Support-only: load a third party's documents into the vector store, skipping those already there.
 * Threat-scenario evaluation calls it before the agent searches them.
 *
 * @generated from rpc artifacts.analyzer.v1.AnalyzerService.IndexCompanyResources
 */
export const indexCompanyResources = AnalyzerService.method.indexCompanyResources;
